import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
          热门分类板块
        </h2>
        <p className="text-sm text-foreground-600 mt-2">
          八大主题分类，总有你感兴趣的话题
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all duration-300 group cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors mb-3">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-500 mt-1 text-center line-clamp-1">
              {cat.description}
            </p>
            <span className="text-xs text-foreground-400 mt-2">
              {cat.postCount >= 1000 ? `${(cat.postCount / 1000).toFixed(1)}k` : cat.postCount} 帖子
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}